export var FormGridColumnTypes;
(function (FormGridColumnTypes) {
    FormGridColumnTypes["Text"] = "text";
    FormGridColumnTypes["Radio"] = "radio";
    FormGridColumnTypes["Select"] = "select";
    FormGridColumnTypes["Checkbox"] = "checkbox";
})(FormGridColumnTypes || (FormGridColumnTypes = {}));
